import { jsx as _jsx } from "react/jsx-runtime";
import styled from 'styled-components';
import ProgressIndicatorText from '../../atoms/timeline/ProgressIndicatorText';
const StyledIndicator = styled.div `
    position: relative;
    transform: translateY(-50%);
    margin-left: 1.5px;
    white-space: nowrap;
`;
const ProgressIndicator = ({ value }) => (_jsx(StyledIndicator, { children: _jsx(ProgressIndicatorText, { children: value }) }));
export default ProgressIndicator;
